import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { compose, setPropTypes, withState, withHandlers } from 'recompose';
import { withRouter } from 'react-router';
import { withStyles } from '@material-ui/core/styles';
import {
  Button,
  Checkbox,
  Divider,
  FormControlLabel,
  Link,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableRow,
  Typography
} from '@material-ui/core';
import { Text } from 'recharts';
import PublicHeader from '../../components/PublicHeader';
import PublicFooter from '../../components/PublicFooter';
import StepProgressBar from '../../components/atoms/StepProgressBar';

const styles = theme => ({
  wrapper: {
    position: 'absolute',
    top: 0,
    left: 0
  },
  page: {
    paddingLeft: 15,
    paddingRight: 15
  },
  paper: {
    display: 'flex',
    flexDirection: 'column',
    marginTop: 20,
    paddingTop: theme.spacing(1)
  },
  titleGroup: {
    marginTop: 20,
    marginBottom: 20,
    display: 'flex',
    alignItems: 'flex-start'
  },
  pagerInDiv: {
    padding: 20
  },
  redText: {
    color: '#FF0000'
  },
  tableTitle: {
    fontSize: 16,
    marginBottom: '20px'
  },
  detailTable: {
    width: '100%'
  },
  tableCellItem: {
    borderBottom: '1px solid #E0E0E0',
    backgroundColor: '#F7F7F7',
    width: '115px',
    padding: '13px 8px',
    fontSize: 12,
    fontWeight: 700
  },
  tableCellData: {
    borderBottom: '1px solid #E0E0E0',
    padding: '13px 8px',
    fontSize: 12,
    fontWeight: 500
  },
  textLabel: {
    fontSize: 12,
    fontWeight: 600
  },
  linkToPrev: {
    display: 'flex',
    justifyContent: 'center',
    paddingTop: 20
  }
});

const propTypes = {
  classes: PropTypes.object.isRequired
};

const enhance = compose(
  connect(state => ({
    prefectures: state.commons.prefectures,
    shopCategories: state.commons.shopCategories
  })),
  setPropTypes(propTypes),
  withState('openProgress', 'updateOpenProgress', false),
  withState('loading', 'updateLoading', false),
  withState('resultMessage', 'setResultMessage', ''),
  withState('titleMessage', 'setTitleMessage', ''),
  withState('btnText', 'setBtnText', '入力画面に戻る'),
  withState('consent', 'setConsent', false),
  withHandlers({
    handleRedirect: props => path => {
      props.history.push(path);
    }
  })
);

const Main = enhance(
  ({
    classes,
    addConfirm,
    registerAction,
    handleBack,
    prefectures,
    shopCategories,
    consent,
    setConsent
  }) => {
    return (
      <div className={classes.wrapper}>
        <PublicHeader />
        <div className={classes.page}>
          <div className={classes.titleGroup}>
            <Typography component="h2" variant="h5">
              アカウント登録情報の確認
            </Typography>
          </div>

          <StepProgressBar currentStep={2} />

          <Paper className={classes.paper} elevation={1}>
            <div className={classes.pagerInDiv}>
              <Typography variant="body2">
                こちらでご登録いただくメールアドレスは、購入・利用時の通知先として利用されます。メールアドレスは管理システムへのログイン時に必要です。
                <br />
                <br />
                <span className={classes.redText}>
                  ※登録完了後、gochimeshi.com、gigi.tokyoドメインからメールが送信されます。メールを受信できるよう、あらかじめメール設定のご確認をお願いいたします。
                </span>
              </Typography>
            </div>
            <Divider />
            <div className={classes.pagerInDiv}>
              <p className={classes.tableTitle}>
                登録するアカウント情報をご確認ください。
              </p>
              <Table className={classes.detailTable}>
                <TableBody>
                  <TableRow>
                    <TableCell className={classes.tableCellItem}>
                      メールアドレス
                    </TableCell>
                    <TableCell className={classes.tableCellData}>
                      {addConfirm.email}
                    </TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell className={classes.tableCellItem}>
                      店舗名
                    </TableCell>
                    <TableCell className={classes.tableCellData}>
                      {addConfirm.shopName}
                    </TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell className={classes.tableCellItem}>
                      店舗名かな
                    </TableCell>
                    <TableCell className={classes.tableCellData}>
                      {addConfirm.shopNameKana}
                    </TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell className={classes.tableCellItem}>
                      郵便番号
                    </TableCell>
                    <TableCell className={classes.tableCellData}>
                      {addConfirm.zipCode}
                    </TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell className={classes.tableCellItem}>
                      都道府県
                    </TableCell>
                    <TableCell className={classes.tableCellData}>
                      {prefectures.map(item => {
                        if (
                          addConfirm.prefectureCode.toString() ===
                          item.id.toString()
                        ) {
                          return item.name;
                        }
                        return '';
                      })}
                    </TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell className={classes.tableCellItem}>
                      市区町村
                    </TableCell>
                    <TableCell className={classes.tableCellData}>
                      {addConfirm.city}
                    </TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell className={classes.tableCellItem}>
                      町域・番地
                    </TableCell>
                    <TableCell className={classes.tableCellData}>
                      {addConfirm.address1}
                    </TableCell>
                  </TableRow>
                  {/* <TableRow>
                    <TableCell className={classes.tableCellItem}>
                      番地
                    </TableCell>
                    <TableCell className={classes.tableCellData}>
                      {addConfirm.address2}
                    </TableCell>
                  </TableRow> */}
                  <TableRow>
                    <TableCell className={classes.tableCellItem}>
                      建物名
                    </TableCell>
                    <TableCell className={classes.tableCellData}>
                      {addConfirm.building}
                    </TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell className={classes.tableCellItem}>
                      店舗カテゴリー
                    </TableCell>
                    <TableCell className={classes.tableCellData}>
                      {shopCategories.map(item => {
                        if (
                          addConfirm.shopCategoryId &&
                          addConfirm.shopCategoryId.toString() ===
                            item.id.toString()
                        ) {
                          return item.name;
                        }
                        return '';
                      })}
                    </TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell className={classes.tableCellItem}>
                      店舗電話番号
                    </TableCell>
                    <TableCell className={classes.tableCellData}>
                      {addConfirm.phone}
                    </TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell className={classes.tableCellItem}>
                      運営会社名
                    </TableCell>
                    <TableCell className={classes.tableCellData}>
                      {addConfirm.shopGroupName}
                    </TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell className={classes.tableCellItem}>
                      ご担当者名
                    </TableCell>
                    <TableCell className={classes.tableCellData}>
                      {addConfirm.shopContactName}
                    </TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell className={classes.tableCellItem}>
                      所属部署
                    </TableCell>
                    <TableCell className={classes.tableCellData}>
                      {addConfirm.department}
                    </TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell className={classes.tableCellItem}>
                      ご担当者電話番号
                    </TableCell>
                    <TableCell className={classes.tableCellData}>
                      {addConfirm.contactPhone}
                    </TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell className={classes.tableCellItem}>
                      インボイス制度 適格事業者登録
                    </TableCell>
                    <TableCell className={classes.tableCellData}>
                      {addConfirm.registrationId ? '登録済み' : '未登録'}
                    </TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell className={classes.tableCellItem}>
                      適格事業者登録番号
                    </TableCell>
                    <TableCell className={classes.tableCellData}>
                      {addConfirm.registrationId}
                    </TableCell>
                  </TableRow>
                </TableBody>
              </Table>
            </div>
            <Divider />
            <div className={classes.pagerInDiv}>
              <Typography variant="p">
                ご登録にあたっては、
                <Link
                  href="https://gochimeshi.com/policy/owner-terms/"
                  target="_blank"
                  rel="noreferrer"
                >
                  加盟店規約
                </Link>
                ・
                <Link
                  href="https://gochimeshi.com/policy/privacy/"
                  target="_blank"
                  rel="noreferrer"
                >
                  プライバシーポリシー
                </Link>
                をご参照、ご同意いただけますようお願いいたします。
              </Typography>
              <br />
              <FormControlLabel
                control={
                  <Checkbox
                    checked={consent}
                    onChange={e => {
                      setConsent(e.target.checked);
                    }}
                    color="primary"
                  />
                }
                label={
                  <Text className={classes.textLabel}>
                    加盟店規約・プライバシーポリシーに同意する
                  </Text>
                }
              />
            </div>
            <Divider />
            <div className={classes.pagerInDiv}>
              <Button
                type="button"
                fullWidth
                variant="contained"
                color="primary"
                onClick={registerAction}
                disabled={!consent}
              >
                アカウントを登録
              </Button>
            </div>
          </Paper>
        </div>
        <div className={classes.linkToPrev}>
          <Button color="primary" onClick={handleBack}>
            入力画面に戻る
          </Button>
        </div>
        <PublicFooter />
      </div>
    );
  }
);

export default withRouter(withStyles(styles)(Main));
